import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/ui-custom/Header';
import Footer from './components/ui-custom/Footer';
import ScrollToTop from './components/ui-custom/ScrollToTop';
import Home from './pages/Home';
import Plumbing from './pages/services/Plumbing';
import Electrical from './pages/services/Electrical';
import Residential from './pages/services/Residential';
import Commercial from './pages/services/Commercial';
import About from './pages/About';
import Reviews from './pages/Reviews';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Dothan from './pages/cities/Dothan';
import Enterprise from './pages/cities/Enterprise';
import Ozark from './pages/cities/Ozark';
import Geneva from './pages/cities/Geneva';
import MidlandCity from './pages/cities/MidlandCity';
import Daleville from './pages/cities/Daleville';
import Headland from './pages/cities/Headland';
import Newton from './pages/cities/Newton';
import Rehobeth from './pages/cities/Rehobeth';
import ServiceAreas from './pages/ServiceAreas';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-brand-blue">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services/plumbing" element={<Plumbing />} />
              <Route path="/services/electrical" element={<Electrical />} />
              <Route path="/services/residential" element={<Residential />} />
              <Route path="/services/commercial" element={<Commercial />} />
              <Route path="/about" element={<About />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/contact-us" element={<Contact />} />
              <Route path="/terms-of-service" element={<Terms />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/service-areas" element={<ServiceAreas />} />
              <Route path="/service-areas/dothan-al" element={<Dothan />} />
              <Route path="/service-areas/enterprise-al" element={<Enterprise />} />
              <Route path="/service-areas/ozark-al" element={<Ozark />} />
              <Route path="/service-areas/geneva-al" element={<Geneva />} />
              <Route path="/service-areas/midland-city-al" element={<MidlandCity />} />
              <Route path="/service-areas/daleville-al" element={<Daleville />} />
              <Route path="/service-areas/headland-al" element={<Headland />} />
              <Route path="/service-areas/newton-al" element={<Newton />} />
              <Route path="/service-areas/rehobeth-al" element={<Rehobeth />} />

              <Route path="/blog/:slug" element={<BlogDetail />} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
